<template>
	<el-card shadow="never" class="aui-card--fill">
		<el-row style="background-color: #F3F4F4;">
			<el-col :xs="24" :md="6" style="line-height: 40px;font-size: 16px;color: #121212;font-weight: bold;">
				<img style="width: 16px;height: 16px;margin-right: 12px;" src="../../../assets/img/user-list.png" />
				完税凭证
			</el-col>
			<el-col :xs="24" :md="18">
				
				<el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()" style="text-align: right;">
					<el-form-item>
						<el-button type="primary" @click="handleImport()"  v-if="$hasPermission('plat:platdutypaid:add')">新增完税凭证</el-button>
					</el-form-item>
					<el-form-item><el-button type="info" @click="getDataList()">刷新</el-button></el-form-item>
				</el-form>
			</el-col>
		</el-row>
		<div class="mod-plat__platticketrecord}">
			
			<el-form  style="padding:10px 5px 0px;" :label-width="'140px'" :model="dataForm" ref="loginFormRef" @keyup.enter.native="getDataList()">
				<el-row>
					<el-col :md="8" :lg="6">
						<el-form-item label="上传月份:" prop="createDate">
							<el-date-picker type="month" style="width:100%;" v-model="dataForm.createDate" placeholder="上传月份" format="yyyy-MM" value-format="yyyy-MM"></el-date-picker>
						</el-form-item>
					</el-col>
					<el-col :md="8" :lg="6">
						<el-form-item label="操作人:" prop="createName">
							<el-input style="width: 100%;" v-model="dataForm.createName" placeholder="操作人" clearable></el-input>
						</el-form-item>
					</el-col>
					<el-col :md="6" :lg="12">
						<el-form-item label-width="0px">
							<div style="text-align: right;">
								<el-button type="primary" @click="getDataList()">{{ $t('query') }}</el-button>
								<el-button type="info" @click="resetLoginForm">重置</el-button>
							</div>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
			<el-table v-loading="dataListLoading" :data="dataList" @selection-change="dataListSelectionChangeHandle" style="width: 100%;">
				<!-- <el-table-column type="selection" header-align="center" align="center" width="50"></el-table-column> -->
				<el-table-column label="序号" type="index" width="50" align="center">
					<template slot-scope="scope">
						<span>{{ (page - 1) * limit + scope.$index + 1 }}</span>
					</template>
				</el-table-column>
				<!--<el-table-column prop="id" label="" header-align="center" align="center"></el-table-column>-->
				<el-table-column prop="createDate" label="上传时间" header-align="center" align="center"></el-table-column>
				<el-table-column prop="taxPeriod" label="纳税期" header-align="center" align="center"></el-table-column>
				<el-table-column prop="createName" label="操作人" header-align="center" align="center"></el-table-column>
				<el-table-column label="完税凭证" header-align="center" align="center">
					<template slot-scope="scope">
				    	<el-button type="text" size="small" @click="addOrUpdateHandle(scope.row,1)">查看</el-button>
					</template>
				</el-table-column>
				<el-table-column :label="$t('handle')" fixed="right" header-align="center" align="center" width="150" v-if="$hasPermission('plat:platdutypaid:delete')">
				  <template slot-scope="scope">
				    <el-button type="text" size="small" @click="handleDeleteRow(scope.row.id)">删除</el-button>
				  </template>
				</el-table-column>
			</el-table>
			<el-pagination
				background
				:current-page="page"
				:page-sizes="[10, 20, 50, 100]"
				:page-size="limit"
				:total="total"
				layout="total, sizes, prev, pager, next, jumper"
				@size-change="pageSizeChangeHandle"
				@current-change="pageCurrentChangeHandle"
			></el-pagination>
			<!-- 弹窗, 新增 / 修改 -->
			<add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>
		</div>
		<el-dialog
        v-if="ImportVisible"
        :title="isCook ? '查看完税凭证' : '新增完税凭证'"
        :visible.sync="ImportVisible"
        width="550px"
        :before-close="handlerCloseSubmit"
      >
		<el-form>
		<el-row>
				<el-form-item label="纳税期：" >
					<el-date-picker
						:disabled="isCook ? true : false"
							style="width: 35%"
							v-model="taxPeriod"
							placeholder="选择纳税期"
							value-format="yyyy-MM"
							type="month"
					></el-date-picker>
				</el-form-item>
		</el-row>
		<el-row>
			<el-form-item label="上    传：">
				<div class="batchImport">
					<div v-for="(item, index) in invoicePath" style="display: inline-block; margin: 0px 10px 20px">
						<div style="position: relative">
						<img v-if="item && item.url.indexOf('pdf') === -1" :src="item.url" class="avatar" @click="yulan(item.url)" />
						<img v-else :src="require('../../../assets/img/pdf.png')" class="avatar"  @click="yulan(item.url)"/>
						<span class="editSty" @click.stop="deleteinfo(index)" v-if="!isCook">
							<i class="el-icon-delete"></i>
						</span>
						</div>
					</div>
					<div style="display: inline-block; margin: 0px 10px 20px" v-if="!isCook">
						<el-upload class="avatar-uploader" :action="url" :show-file-list="false" list-type="picture-card" :before-upload="beforeUploadHandle" :on-success="successinvoiceHandle" :on-error="backerror">
						<i class="el-icon-plus avatar-uploader-icon" style="line-height: 60px !important" ></i>
						<div slot="tip" class="el-upload__tip">
							支持上传PDF、图片等
						</div>
						</el-upload>
					</div>
				</div>
			</el-form-item>
		</el-row>
			</el-form>
        
        <div slot="footer" class="dialog-footer">
          <el-button @click="closeSubmit">取 消</el-button>
          <el-button v-no-more-click type="primary" @click="confirmSubmit" v-if="!isCook" :disabled="invoicePath.length <1 ? true : false">确 定</el-button>
        </div>
      </el-dialog>
	  <dialog-tips
		v-if="dialogTipsVisible"
		:DailogVisible="dialogTipsVisible"
		:TipsInfo="tipsInfoList"
		@handleClose="handleClose"
		>
		</dialog-tips>
		<el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>
	</el-card>
</template>

<script>
import mixinViewModule from '@/mixins/view-module'
import AddOrUpdate from './platjxticket-add-or-update'
import Cookies from 'js-cookie'
import DialogTips from "./batch-settlement/components/dialog-tips.vue";

export default {
  mixins: [mixinViewModule],
  data () {
    return {
		taxPeriod:'',//完税日期
		dialogVisible: false,
      dialogImageUrl: "",
		isCook:false,
		url: `${ window.SITE_CONFIG["apiURL"] }/oss/file/upload2?access_token=${Cookies.get("access_token")}`,
      options: [
        {
          value: '0',
          label: '未开票'
        },
        {
          value: '1',
          label: '已开票'
        }
      ],
      value: '',
      role: Cookies.get('admin_role'),
      mixinViewModuleOptions: {
        getDataListURL: '/sys/plat/task/getCertificateList',
        getDataListIsPage: true,
        deleteURL: '/sys/plat/task/deleteCertificateById',
        deleteIsBatch: true,
      },
      dataForm: {
		createDate:'',
		createName:''
      },
	  dialogTipsVisible:false,
	  tipsInfoList:null,
	  ImportVisible:false,
	  invoicePath:[],
    }
  },
  components: {
    AddOrUpdate,
    DialogTips,
  },
  methods: {
	  resetLoginForm () {
      this.$refs.loginFormRef.resetFields()
      this.dataForm.createDate = ''
      this.dataForm.createName = ''
      this.getDataList()
    },
	// 删除数据
	handleDeleteRow(id){
		this.$confirm(this.$t('prompt.info', { 'handle': this.$t('delete') }), this.$t('prompt.title'), {
			confirmButtonText: this.$t('confirm'),
			cancelButtonText: this.$t('cancel'),
			type: 'warning'
		}).then(() => {
			this.$http.post(this.mixinViewModuleOptions.deleteURL,{id}).then(({data:res}) => {
				if (res.code !== 0) {
					return this.$message.error(res.msg)
				}
				this.$message({
					message: res.data,
					type: 'success',
					duration: 500,
					onClose: () => {
						this.getDataList()
					}
				})
			})
		})
	},
	//导入
    handleImport() {
		this.taxPeriod = ''
		this.invoicePath = [];
		this.isCook = false;
      this.ImportVisible = true;
    },
	//关闭提示框
    handleClose(val) {
      this.dialogTipsVisible = val;
    },
	handlerCloseSubmit(){
		this.ImportVisible = false;
	},
	closeSubmit(){
		this.ImportVisible = false;
	},
	async confirmSubmit(){
		if(this.taxPeriod == ''){
			return this.$message.error('请选择纳税期！')
		}
		const res = await this.$http.post(`/sys/plat/task/uploadCertificate?taxPeriod=${this.taxPeriod}`,JSON.stringify(this.invoicePath),{
	    	headers: {
	    		'content-type': 'application/json;charset=UTF-8'
	    	}
	    });
		if (res.data.code !== 0) {
			return this.$message.error(res.data.msg);
		}
		this.$message.success(res.data.data);
		this.ImportVisible = false;
		this.getDataList();
	},
	// 查看完税证明
	addOrUpdateHandle(row,isCook){
		this.invoicePath = [];
		let list = row.ossUrl.split(",")
		list.map((item,index) => {
			this.invoicePath.push({
				url:item
			})
		})
		this.taxPeriod = row.taxPeriod
      this.ImportVisible = true;
	  this.isCook = isCook;
	},
	beforeUploadHandle(file) {
      if (
        file.type != "application/pdf" &&
        file.type !== "image/jpg" &&
        file.type !== "image/jpeg" &&
        file.type !== "image/png" &&
        file.type !== "image/gif"
      ) {
        this.$message.error(
          this.$t("upload.tip", { format: "jpg、png、gif,pdf" })
        );
        return false;
      }
      this.num++;
    },
    // 上传成功
    successHandle(res, file, fileList) {
      if (res.code !== 0) {
        return this.$message.error(res.msg);
      }
      if (res.code == 0) {
        this.type = res.data.fileType;
        this.paymentVoucher = res.data.url;
      } else {
        this.$message.error("上传失败，请重试");
      }

      this.num--;
    },
    successinvoiceHandle(res, file, fileList) {
      if (res.code !== 0) {
        return this.$message.error(res.msg);
      }
      if (res.code == 0) {
        this.invoicePath.push({url:res.data.url,id:res.data.id});
        // this.invoicePath = this.invoicePath.join(",");
		console.log(this.invoicePath)
      } else {
        this.$message.error("上传失败，请重试");
      }

      this.num--;
    },
    deleteinfo(index) {
      let that = this;
      this.$confirm("确认删除附件吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          that.invoicePath.splice(index, 1);
        //   that.invoicePath = that.invoicePath.join(",");
        })
        .catch(() => {});
    },
    delPayment() {
      this.paymentVoucher = "";
    },
    yulan(url) {
      if (url.indexOf("pdf") === -1) {
        this.dialogImageUrl = url;
        this.dialogVisible = true;
      } else {
        window.open(url, url);
      }
    },
	backerror(e) {
      this.$message.error("文件上传失败，请重试");
    },
  }
}
</script>
<style lang="scss" scoped>
	.el-upload--picture-card{
		width: 100px !important;
		height: 100px !important;
		line-height: 110px !important;
	}
	.editSty{
		position: absolute;
		right: 0;
		bottom: 0;
		padding: 5px;
		background: red;
		color: #fff;
		cursor: pointer;
		font-size: 16px;
	}
</style>